import React, { useEffect, useState } from 'react';
import styles from '../styles.module.scss';

const Index = ({ list }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentIndex < list[0]?.length)
        setCurrentIndex((prevIndex) => (prevIndex + 1) % list[0]?.length);
      else setCurrentIndex(0);
    }, 600);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {list?.map((value, index) => (
        <div
          className={`${styles.coveragePill} ${
            currentIndex === index ? styles?.activeCoveragePill : ''
          }`}
          key={index}
        >
          {value}
        </div>
      ))}
    </>
  );
};

export default Index;
